// extracted by mini-css-extract-plugin
export default {"status":"AssociatedItems_status__Ox7TL","active":"AssociatedItems_active__QGDdY","inactive":"AssociatedItems_inactive__knmiU"};